<template lang="pug">
  v-carousel(
    v-if='bannerUrl.length!==0'
    :show-arrows="bannerUrl.length!==1"
    hide-delimiters
    cycle
    height="auto"
    style="border-radius: 8px;"
  ).mt-2
    v-carousel-item(
      v-for='(item,i) in bannerUrl'
      :key='i'
      :src='item.link_url'
    ).c-banner 
</template>
<script>     
import { banners as apiBanner } from '@/apis'  
export default {  
  components : {
  },

  data: () => ({
    bannerUrl : [],
    innerWidth: window.innerWidth
  }), 
  computed : { 
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    isMobile () {
      return this.innerWidth < 640
    },

    bannerHeight () {
      const width = this.innerWidth

      if (width < 640) {
        return 120
      } else if (width < 1000) {
        return 220
      } else {
        return 320
      }
    }
  },   

  async mounted () {     
    await this.getBanner ();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    // this.$nextTick(()=>this.$refs.dialogroulete.open())
  },   
  
  methods: {  

    async getBanner () { 
      const [err,data,] =  await apiBanner.get({ type_id: 1 })
      
      if(err) {
        return
      }
      this.bannerUrl = data 
    }, 

    onResize () {
      this.innerWidth = window.innerWidth
    },
  }
}
</script>
<style scoped>

.c-banner >>> .v-image__image {
  background-size: contain;
}

@media only screen and (max-width: 640px) {
  .v-layout1 {
    padding-left: 8px;
    padding-right: 8px;
  }
}

</style>